import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Header, About, People, Contact, Services, Footer } from "./components";
import Privacidad from "./pages/Privacidad";
import Cookies from "./pages/Cookies";
import Legal from "./pages/Legal";
import { CookieConsent } from "./components/CookieConsent";
import styles from "./components/Header.module.scss";

// Extract Home Header Content to a component to avoid inline bloat and access context like handleScroll if needed
const HomeHero = () => {
    const navigate = useNavigate();
    const location = useLocation();
  
    const handleScroll = (id) => {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) element.scrollIntoView({ behavior: "smooth" });
        }, 300);
      } else {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }
    };

    return (
        <>
        <h1 className={styles.title}>
          Profesionalidad, dedicación y confianza
        </h1>
        <h2 className={styles.subtitle}>
          Somos Gallur Montesinos, tu{" "}
          <span className="highlight">Administrador de fincas</span> en Petrer
        </h2>
        <p className={styles.contact}>
          <a onClick={() => handleScroll("contact")}>Contacto</a>
        </p>
        </>
    );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header>
                <HomeHero />
              </Header>
              <Services />
              <About />
              <People />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/legal" element={<Legal />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
